var _g, _path, _path2, _path3, _path4, _path5, _path6, _g2, _g3, _g4, _g5, _g6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfetti1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 123,
    viewBox: "0 0 227 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3729_42515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.425 28.0222C144.193 28.233 142.431 29.4444 141.396 30.3901C141.154 30.611 141.1 30.9682 141.255 31.2564C143.7 35.7899 146.891 38.104 148.68 38.9833C148.875 39.0791 149.077 38.8888 149.011 38.6819C147.99 35.4592 148.042 32.0344 147.945 28.5014C147.937 28.2234 147.703 28.0042 147.425 28.0222Z",
    fill: "#FFC140"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M226.429 92.9442C225.838 93.3294 225.333 93.836 224.952 94.4279C224.866 94.561 224.667 94.5612 224.581 94.4284C224.198 93.8376 223.692 93.3324 223.099 92.9488C222.967 92.8637 222.967 92.6691 223.098 92.5836C223.69 92.1984 224.195 91.6919 224.576 91.1C224.662 90.9669 224.861 90.9666 224.947 91.0995C225.33 91.6903 225.836 92.1955 226.429 92.579C226.561 92.6642 226.561 92.8587 226.429 92.9442Z",
    fill: "#3ABDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4295 52.9442C45.8375 53.3294 45.3331 53.836 44.9517 54.4279C44.8659 54.561 44.667 54.5612 44.5808 54.4284C44.1978 53.8376 43.6919 53.3324 43.0989 52.9488C42.9673 52.8637 42.967 52.6691 43.0984 52.5836C43.6903 52.1984 44.1948 51.6919 44.5761 51.1C44.6619 50.9669 44.8608 50.9666 44.947 51.0995C45.33 51.6903 45.8359 52.1955 46.4289 52.579C46.5606 52.6642 46.5609 52.8587 46.4295 52.9442Z",
    fill: "#3ABDFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42948 92.9442C6.83755 93.3294 6.33305 93.836 5.95167 94.4279C5.86589 94.561 5.667 94.5612 5.58084 94.4284C5.19779 93.8376 4.69192 93.3324 4.09888 92.9488C3.96726 92.8637 3.96698 92.6691 4.09838 92.5836C4.69032 92.1984 5.19481 91.6919 5.57614 91.1C5.66192 90.9669 5.86081 90.9666 5.94697 91.0995C6.33001 91.6903 6.83595 92.1955 7.42893 92.579C7.5606 92.6642 7.56088 92.8587 7.42948 92.9442Z",
    fill: "#FDAD28"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4295 112.944C97.8375 113.329 97.3331 113.836 96.9517 114.428C96.8659 114.561 96.667 114.561 96.5808 114.428C96.1978 113.838 95.6919 113.332 95.0989 112.949C94.9673 112.864 94.967 112.669 95.0984 112.584C95.6903 112.198 96.1948 111.692 96.5761 111.1C96.6619 110.967 96.8608 110.967 96.947 111.099C97.33 111.69 97.8359 112.195 98.4289 112.579C98.5606 112.664 98.5609 112.859 98.4295 112.944Z",
    fill: "#1BE1D4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M139.429 12.9423C138.838 13.3275 138.333 13.834 137.952 14.4259C137.866 14.559 137.667 14.5593 137.581 14.4264C137.198 13.8356 136.692 13.3304 136.099 12.9469C135.967 12.8618 135.967 12.6672 136.098 12.5817C136.69 12.1965 137.195 11.6899 137.576 11.098C137.662 10.9649 137.861 10.9647 137.947 11.0975C138.33 11.6884 138.836 12.1935 139.429 12.5771C139.561 12.6622 139.561 12.8568 139.429 12.9423Z",
    fill: "#FD5382"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3699 52.6698C8.63247 52.2666 4.34024 48.7219 2.7863 47C1.19036 47.84 -1.37153 50.2759 0.896375 57.8356C3.16428 65.3953 10.346 62.4974 14.3778 61.1114C18.4097 59.7255 23.7015 62.1194 24.3314 62.4974C24.533 60.7838 23.1555 58.4235 22.4415 57.4576C21.3916 56.0296 18.1073 53.073 13.3699 52.6698Z",
    fill: "url(#paint0_linear_3729_42515)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3729_42515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.4512 13.2532C43.066 13.5737 42.0551 19.718 42.0551 19.718C42.0551 19.718 39.7968 17.6351 37.7411 17.1699C34.6195 16.4636 29.235 18.816 29.235 18.816C29.235 18.816 34.3906 12.8046 39.4512 13.2532Z",
    fill: "#FFC140"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_3729_42515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.943 95.9344C109.946 87.6184 114.007 80.0203 126.294 84.1065C127.723 84.582 128.555 86.0382 128.374 87.5339C128.095 89.8411 125.615 91.1543 123.41 90.4187C113.545 87.1269 110.291 92.5032 107.867 96.5598L107.943 95.9344Z",
    fill: "url(#paint1_linear_3729_42515)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_3729_42515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.509 94.8616C107.361 99.8848 105.589 104.893 99.1337 102.748C98.1772 102.43 97.5851 101.497 97.5681 100.489C97.5345 98.4934 99.6688 97.235 101.593 97.7648C105.731 98.904 107.383 96.9746 108.59 94.7637L108.509 94.8616Z",
    fill: "url(#paint2_linear_3729_42515)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_3729_42515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.5408 38.1953C91.0145 38.8832 82.5292 37.3925 82.5827 24.4447C82.589 22.9382 83.7134 21.6937 85.1909 21.3994C87.4701 20.9453 89.4909 22.8928 89.479 25.2169C89.4259 35.6167 95.5485 37.0328 100.159 38.0723L99.5408 38.1953Z",
    fill: "url(#paint3_linear_3729_42515)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_3729_42515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.3453 37.9924C103.476 37.5171 108.787 37.6398 108.761 44.4427C108.757 45.4506 108.055 46.304 107.102 46.6342C105.216 47.2881 103.356 45.6523 103.259 43.6586C103.052 39.3719 100.704 38.4038 98.227 37.9458L98.3453 37.9924Z",
    fill: "url(#paint4_linear_3729_42515)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_3729_42515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.284 12.2134C194.193 8.36025 194.106 4.3278 200.057 3.17504C200.749 3.04091 201.423 3.44415 201.693 4.09592C202.108 5.1014 201.398 6.20653 200.329 6.4124C195.548 7.33366 195.455 10.2742 195.396 12.486L195.284 12.2134Z",
    fill: "url(#paint5_linear_3729_42515)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_3729_42515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.268 11.6453C195.953 13.9583 196.38 16.4087 193.253 17.015C192.79 17.1049 192.334 16.8601 192.096 16.4528C191.624 15.6461 192.206 14.6428 193.113 14.4172C195.063 13.9323 195.294 12.7659 195.279 11.5867L195.268 11.6453Z",
    fill: "url(#paint6_linear_3729_42515)"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_3729_42515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.1 104.122C46.275 105.159 52.0313 107.734 49.6777 116.915C49.4039 117.983 48.3832 118.666 47.2818 118.61C45.5828 118.525 44.4967 116.781 44.9208 115.134C46.8184 107.761 42.7259 105.661 39.6395 104.099L40.1 104.122Z",
    fill: "url(#paint7_linear_3729_42515)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9117 104.48C37.185 103.9 33.437 102.863 34.6725 98.0388C34.8556 97.3241 35.5065 96.8439 36.2415 96.7798C37.697 96.6529 38.7253 98.1469 38.4371 99.5792C37.8176 102.659 39.3111 103.766 40.9873 104.534L40.9117 104.48Z",
    fill: "url(#paint8_linear_3729_42515)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3729_42515",
    x: 140.16,
    y: 28.0215,
    width: 9.87236,
    height: 13.0032,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.00796
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.50398
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3729_42515"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3729_42515",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3729_42515",
    x: 28.2269,
    y: 13.2295,
    width: 14.9661,
    height: 8.5042,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.00796
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.50398
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3729_42515"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3729_42515",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_3729_42515",
    x: 95.552,
    y: 82.9678,
    width: 34.8629,
    height: 24.8259,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.5199
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.00796
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3729_42515"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3729_42515",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_3729_42515",
    x: 92.2761,
    y: 94.7637,
    width: 21.6055,
    height: 19.5817,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.79577
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.64589
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3729_42515"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3729_42515",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_3729_42515",
    x: 80.5666,
    y: 21.333,
    width: 30.2101,
    height: 29.9831,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.5199
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.00796
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3729_42515"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3729_42515",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_3729_42515",
    x: 92.9353,
    y: 37.8271,
    width: 21.1173,
    height: 20.0407,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.79577
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.64589
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3729_42515"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3729_42515",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_3729_42515",
    x: 189.912,
    y: 3.14941,
    width: 13.9171,
    height: 18.4196,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.5199
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.00796
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3729_42515"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3729_42515",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_3729_42515",
    x: 186.636,
    y: 11.5869,
    width: 14.4122,
    height: 16.5338,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.79577
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.64589
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3729_42515"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3729_42515",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_3729_42515",
    x: 31.9122,
    y: 95.2605,
    width: 20.824,
    height: 26.8806,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.00796
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.25995
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3729_42515"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3729_42515",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3729_42515",
    x1: 0,
    y1: 47,
    x2: 27.3409,
    y2: 60.3555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BE1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "#1FDACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#67ECE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BE1D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3729_42515",
    x1: 117.182,
    y1: 83.4917,
    x2: 118.816,
    y2: 95.2389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD5382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF94B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3729_42515",
    x1: 103.251,
    y1: 102.861,
    x2: 102.088,
    y2: 95.6956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD5382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF94B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3729_42515",
    x1: 84.8383,
    y1: 33.2942,
    x2: 95.4912,
    y2: 28.0806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D153FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B094FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3729_42515",
    x1: 107.585,
    y1: 40.4951,
    x2: 101.139,
    y2: 43.8338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E53FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D094FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3729_42515",
    x1: 196.198,
    y1: 5.01559,
    x2: 199.561,
    y2: 9.43391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D153FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B094FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3729_42515",
    x1: 194.959,
    y1: 16.1162,
    x2: 192.839,
    y2: 13.4595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E53FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D094FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3729_42515",
    x1: 50.2998,
    y1: 111.698,
    x2: 39.2855,
    y2: 111.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3ABDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5E0FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3729_42515",
    x1: 34.4026,
    y1: 100.222,
    x2: 41.1869,
    y2: 100.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3ABDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5E0FE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfetti1);
export default __webpack_public_path__ + "static/media/confetti1.24dd005b774c312e25f4c25d1388a0ad.svg";
export { ForwardRef as ReactComponent };